import React from "react";
import { reduxForm, Field } from "redux-form";

import Textarea from "../../../../../components/common/textarea/Textarea";
import { maxLength } from "../../../../../utils/forms/validators";

import styles from "./rejectProjectModal.scss";
import close from "../../../../../assets/images/close-icon.svg";

const maxLengthMessage = maxLength(
  500,
  "Your message must be less than 500 characters long."
);

class RejectProjectModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      message: ""
    };
  }

  handleChange(e) {
    this.setState({ message: e.target.value });
  }

  render() {
    const { onHide, modalClick } = this.props;

    return (
      <div className={styles.modalcontainer}>
        <img
          src={close}
          className={styles.closebutton}
          onClick={() => onHide()}
        />
        <div className={styles.modalcontent}>
          <div className={styles.header}>
            <h2 className={styles.title}>Reject Project</h2>
          </div>
          <div className={styles.divider}>
            <div className={styles.top} />
            <div className={styles.bottom} />
          </div>
          <div className={styles.intro}>
            <p>
              Fill in the form below to add detail on why this project is not
              being approved. We will include this note in the email the company
              receives.
            </p>
            <Field
              name="message"
              type="textarea"
              component={Textarea}
              className={styles.message}
              onChange={e => this.handleChange(e)}
              value={this.state.message}
              placeholder="Add additional context for project cancellation (optional)."
              maxlength={500}
              validate={[maxLengthMessage]}
            />
            <div>
              <button
                className={styles.acceptButton}
                onClick={() => {
                  modalClick(this.state.message);
                  onHide();
                }}
              >
                REJECT
              </button>
            </div>
            <div>
              <button className={styles.cancelButton} onClick={() => onHide()}>
                CANCEL
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RejectProjectModal = reduxForm({
  form: "RejectProjectModal"
})(RejectProjectModal);

export default RejectProjectModal;



// WEBPACK FOOTER //
// ./src/routes/admin/project/common/components/rejectProjectModal.js